<div class="flex h-full min-h-0" *transloco="let t">
  <div class="flex h-full min-h-0 flex-1 flex-col pb-24">
    @if (organization()?.starterPlanBlacklisted) {
      <div>{{ t("selfservice-freemium.starter_plan_no_available_please_conctat_us") }}</div>
    } @else {
      @if (!currentBillingPlan()) {
        <div class="min-h-0 flex-1">
          <div class="flex h-full min-h-0 flex-1 flex-col">
            <div class="mb-0 px-4 py-2">
              <h2 class="text-gray-800">{{ t("selfservice-freemium.select_account") }}</h2>
            </div>
            <div class="flex min-h-0 flex-1 flex-col">
              <app-billing-account-selection
                class="flex min-h-0 flex-1 flex-col"
                (save)="activate($event)"
                (cancelClicked)="backToHome()"
              ></app-billing-account-selection>
            </div>
          </div>
        </div>
      }
      @if (currentBillingPlan()) {
        <div>{{ t("selfservice-freemium.you_already_have_a_plan") }}</div>
      }
    }
  </div>
</div>
